export const FULL_STORY_BARRY_TRACKING_EVENTS = {
	barryOpened: 'BM: Barry Opened',
	barryMessageSent: 'BM: Barry Message Sent',
	barryNavigateToNewChat: 'BM: Navigate to New Barry Chat',
};
